package team.platforma.aicombo.telegram

import kotlinx.browser.window

actual fun triggerTelegramOauth() {
    val oauthUrl = TgSocial().urlToRequest
    //"https://oauth.telegram.org/auth?bot_id=7831772721&origin=https%3A%2F%2Fmejs.test.x840.ru&embed=1&request_access=write&return_to=https%3A%2F%2Fmejs.test.x840.ru%2F"

    // Open in a new browser tab
    window.location.href = oauthUrl
}

actual fun onTelegramDataReceived(data: String) {
    console.log("Do smth with data:$data")
    window.localStorage.setItem(TgSocial().localStorageTgKey, data)
}

fun checkData(): String? {
    return window.localStorage.getItem(TgSocial().localStorageTgKey)
}

fun saveRedirectTelegramDataToLocalStorage() {
    val href = window.location.href
    console.log("1")
    console.log("is it answer:${href != TgSocial().redirectUrl}")
    if (href != "http://localhost:8080/") {
        if (href != TgSocial().redirectUrl) {

            // try save telegram redirect data
            try {
                val substring = href.substringAfter('#').substringAfter('=')
                if (substring.isNotEmpty()) {
//                    val jsonMap = substring.split("&").associate {
//                        val parts = it.split("=", limit = 2)
//                        val key = parts[0]
//                        val value = if (parts.size > 1) parts[1] else ""
//                        key to value
//                    }
//
//                    val jsonString = substring
//                        jsonMap.entries.joinToString(",", "{", "}") { (key, value) ->
//                        "\"$key\": \"${value}\""
//                    }
                    console.log(4)
                    console.log("Data substring: ${substring}")
                    val parsedString = decodeTgAuthResult(substring)
                    console.log(parsedString)
//                    Json.decodeFromString<VKIDResponse>(json)!!
                    onTelegramDataReceived(parsedString)
//                    window.location.assign(TgSocial().originUrl)
//                    window.location.href = TgSocial().originUrl
//                    if (TgSocial().redirectUrl == "http://localhost") {
//                        window.location.href = "http://localhost:8080"
//                    } else {
//                        window.location.href = TgSocial().redirectUrl
//                    }
                }
            } catch (_: Exception) {
                // nothing to do
            }
        }
    }
}

fun decodeTgAuthResult(encoded: String): String {
    var base64 = encoded.replace('-', '+').replace('_', '/')

    // Добавляем padding, если нужно
    val padding = (4 - base64.length % 4) % 4
    base64 += "=".repeat(padding)

    // Декодируем с помощью atob
    val jsonString = try {
        window.atob(base64)
    } catch (e: Throwable) {
        throw IllegalArgumentException(
            "Невозможно раскодировать строку: неправильный формат Base64",
            e
        )
    }

    // Парсим JSON
    val json = JSON.parse<dynamic>(jsonString)

    // Красиво форматируем
    return JSON.stringify(json, space = 4)
}